/* eslint-disable @typescript-eslint/naming-convention */
import type { LinkedImageList, SiteFooter } from '@ps/web-martech-cms-types';
import React from 'react';
import { useSelector } from 'react-redux';

import { CMSLinkedImageList, useCMSReference } from '@swf/cms';
import { FeatureFlag } from '@swf/core/enums';
import useFeature from '@swf/core/hooks/useFeature';
import { select } from '@swf/core/store';

import styles from './CMSFooter.scss';
import Copyright from './components/Copyright/Copyright';
import FooterMenu from './components/FooterMenu/FooterMenu';
import Logos from './components/Logos/Logos';
import MachineDate from './components/MachineDate/MachineDate';

const CMSFooter: React.FC<SiteFooter> = ({ menu, logos, copyright, social_media }) => {
  const footerDateTimeFlag = useFeature(FeatureFlag.FooterDateTime);
  const isSportsSelfExcluded = useSelector(select.account.isSportsSelfExcluded);
  const socialMedia = useCMSReference<LinkedImageList>(social_media[0]);

  return (
    <footer className={styles.footer} role="contentinfo">
      {!!menu.length && !isSportsSelfExcluded && (
        <div className={styles.footerNavs}>
          {menu.map((subMenu, i) => (
            <FooterMenu key={i} {...subMenu} />
          ))}
        </div>
      )}
      {!!logos.length && <Logos logos={logos} />}
      {!!(copyright || socialMedia) && (
        <div className={styles.footerBottom}>
          <div className={styles.footerBottomInner}>
            {!!copyright && <Copyright copyright={copyright} />}
            {socialMedia && <CMSLinkedImageList {...socialMedia} isFooter type="Social Media" />}
          </div>
        </div>
      )}
      {footerDateTimeFlag && <MachineDate />}
    </footer>
  );
};

export default CMSFooter;
